import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Database, CalendarClock, BarChart3, Cpu, QrCode } from "lucide-react";

const items = [
  { i: Database, title: "ERP Integration", text: "Connect production confirmations, material consumption, job order status, finished goods receipts, traceability and quality results with ERP.", systems: "SAP · Oracle · Microsoft Dynamics / MS365 · other ERP via API" },
  { i: CalendarClock, title: "APS Integration", text: "Send real capacity, machine availability, job status and production feedback to planning systems.", systems: "factory.online and other APS/MOM platforms" },
  { i: BarChart3, title: "BI & Analytics", text: "Use BEEDIGIT dashboards or connect validated production data to BI tools.", systems: "Power BI and other reporting environments" },
  { i: Cpu, title: "Machine & IIoT", text: "Connect machine signals, PLC data, edge devices, sensors, energy meters and industrial data sources.", systems: "MQTT · secure API · edge · PLC protocols" },
  { i: QrCode, title: "Labeling & QR", text: "Connect industrial printers and scanning workflows for complete material and product traceability.", systems: "Industrial printers · handheld scanners" },
];

export default function IntegrationsBlock() {
  const { t } = useLanguage();
  return (
    <section id="integrations" className="py-16 md:py-20 border-t border-border bg-[hsl(var(--section-alt))]">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Integrations")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("Connect BEEDIGIT with your ERP, APS, BI and industrial systems.")}</h2>
          <p className="text-muted-foreground">
            {t("BEEDIGIT does not replace your ERP. It gives ERP and APS systems the real shop-floor data they are missing.")}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it) => (
            <div key={it.title} className="rounded-lg border border-border bg-card p-5">
              <it.i className="h-6 w-6 text-primary mb-3" />
              <h3 className="font-semibold mb-2">{t(it.title)}</h3>
              <p className="text-sm text-muted-foreground mb-3">{t(it.text)}</p>
              <p className="text-[11px] font-mono text-foreground/70 border-t border-border pt-3">{t(it.systems)}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 rounded-lg border border-primary/30 bg-primary/5 p-5 max-w-3xl">
          <p className="text-sm text-foreground/90">
            <span className="font-semibold">{t("ERP")}</span> {t("plans the business.")} <span className="font-semibold">{t("APS")}</span> {t("plans production.")}{" "}
            <span className="text-primary font-semibold">{t("BEEDIGIT")}</span> {t("executes and measures the real factory.")}{" "}
            <span className="font-semibold">{t("BI")}</span> {t("shows management the truth.")}
          </p>
        </div>
        <div className="mt-6">
          <Button variant="outline" asChild>
            <Link to="/integrations">{t("Discuss Integration Scenario")} <ArrowRight className="ms-2 h-4 w-4" /></Link>
          </Button>
        </div>
      </div>
    </section>
  );
}